// semeia-disable-reexport
import AbdominalAreaDeclaredJournalEvent from "parog-web/models/abdominal-area-declared-journal-event";
import AdverseEventDeclaredJournalEvent from "parog-web/models/adverse-event-declared-journal-event";
import BloodPressureMeasuredJournalEvent from "parog-web/models/blood-pressure-measured-journal-event";
import CapillarityBloodGlucoseMeasuredJournalEvent from "parog-web/models/capillarity-blood-glucose-measured-journal-event";
import CrohnSurveyFilledJournalEvent from "parog-web/models/crohn-survey-filled-journal-event";
import DpSessionDeclaredJournalEvent from "parog-web/models/dp-session-declared-journal-event";
import FastDeclaredJournalEvent from "parog-web/models/fast-declared-journal-event";
import FeelingEvasDeclaredJournalEvent from "parog-web/models/feeling-evas-declared-journal-event";
import HemodialysisSessionDeclaredJournalEvent from "parog-web/models/hemodialysis-session-declared-journal-event";
import IbdDiskSurveyFilledJournalEvent from "parog-web/models/ibd-disk-survey-filled-journal-event";
import KfreFiveYearsComputedJournalEvent from "parog-web/models/kfre-five-years-computed-journal-event";
import KfreTwoYearsComputedJournalEvent from "parog-web/models/kfre-two-years-computed-journal-event";
import MammographyDeclaredJournalEvent from "parog-web/models/mammography-declared-journal-event";
import OxygeneSaturationDeclaredJournalEvent from "parog-web/models/oxygene-saturation-declared-journal-event";
import QidsDeclaredJournalEvent from "parog-web/models/qids-declared-journal-event";
import RchSurveyFilledJournalEvent from "parog-web/models/rch-survey-filled-journal-event";
import RespiratoryRateMeasuredJournalEvent from "parog-web/models/respiratory-rate-measured-journal-event";
import StoolsNumberDeclaredJournalEvent from "parog-web/models/stools-number-declared-journal-event";
import TemperatureMeasuredJournalEvent from "parog-web/models/temperature-measured-journal-event";
import ThymicEpisodeOccurredJournalEvent from "parog-web/models/thymic-episode-occurred-journal-event";
import VemsDeclaredJournalEvent from "parog-web/models/vems-declared-journal-event";
import VitalSign from "parog-web/models/vital-sign";
import WeightMeasuredJournalEvent from "parog-web/models/weight-measured-journal-event";
import YmrsDeclaredJournalEvent from "parog-web/models/ymrs-declared-journal-event";

export function vitalSignsOrderGivenFur(fur: string): string[] {
  switch (fur) {
    case "digest-rch":
      return ["rch-survey", "ibd-disk-survey", "stools-number", "weight"];
    case "digest-crohn":
      return ["crohn-survey", "ibd-disk-survey", "stools-number", "weight"];
    default:
      return [];
  }
}

export function loadVitalSigns(): void {
  new VitalSign({
    key: "blood-pressure",
    contextualDeclareRoute: "blood-pressure.sessions",
    journalEventType: BloodPressureMeasuredJournalEvent,
    icon: "heartbeat",
    tooltipIcon: "heartbeat",
    showToPatient: true
  });

  new VitalSign({
    key: "respiratory-rate",
    addMeasureForcId: "respiratory-rate/edition-form",
    journalEventType: RespiratoryRateMeasuredJournalEvent,
    icon: "wind",
    tooltipIcon: "wind",
    showToPatient: true,
    contextualDeclareRoute: "dashboard.main.results-table.respiratory-rate"
  });

  new VitalSign({
    key: "temperature",
    addMeasureForcId: "temperature/edition-form",
    journalEventType: TemperatureMeasuredJournalEvent,
    icon: "thermometer half",
    tooltipIcon: "thermometer half",
    showToPatient: true,
    contextualDeclareRoute: "dashboard.main.results-table.temperature"
  });

  new VitalSign({
    key: "weight",
    addMeasureForcId: "measurements/weight-edition-form",
    journalEventType: WeightMeasuredJournalEvent,
    icon: "weight",
    tooltipIcon: "weight",
    showToPatient: true,
    contextualDeclareRoute: "dashboard.main.results-table.measurements"
  });

  new VitalSign({
    key: "adverse-events",
    addMeasureForcId: "adverse-events/edition-form",
    journalEventType: AdverseEventDeclaredJournalEvent,
    icon: "meh outline",
    showToPatient: true,
    contextualDeclareRoute: "dashboard.main.results-table.adverse-event"
  });

  new VitalSign({
    key: "capillarity-blood-glucose",
    addMeasureForcId: "capillarity-blood-glucose/edition-form",
    journalEventType: CapillarityBloodGlucoseMeasuredJournalEvent,
    icon: "hand pointer outline",
    showToPatient: true,
    contextualDeclareRoute:
      "dashboard.main.results-table.capillarity-blood-glucose"
  });

  new VitalSign({
    key: "kfre-five-years",
    contextualDeclareRoute: "dashboard.main.kfre-five-years-edition-form",
    journalEventType: KfreFiveYearsComputedJournalEvent,
    icon: "pump medical",
    showToPatient: false
  });

  new VitalSign({
    key: "kfre-two-years",
    contextualDeclareRoute: "dashboard.main.kfre-two-years-edition-form",
    journalEventType: KfreTwoYearsComputedJournalEvent,
    icon: "pump medical",
    showToPatient: false
  });

  new VitalSign({
    key: "abdominal-area",
    addMeasureForcId: "abdominal-area/edition-form",
    journalEventType: AbdominalAreaDeclaredJournalEvent,
    icon: "ruler combined",
    showToPatient: true,
    contextualDeclareRoute: "dashboard.main.results-table.measurements"
  });

  new VitalSign({
    key: "eva",
    addMeasureForcId: "feeling-evas/form",
    journalEventType: FeelingEvasDeclaredJournalEvent,
    icon: "smile",
    showToPatient: true,
    contextualDeclareRoute: "dashboard.main.results-table.feeling-evas"
  });

  new VitalSign({
    key: "fast",
    addMeasureForcId: "scale-surveys/fast-edition-form",
    journalEventType: FastDeclaredJournalEvent,
    contextualDeclareRoute: "dashboard.main.results-table.scale-surveys"
  });

  new VitalSign({
    key: "qids",
    addMeasureForcId: "scale-surveys/qids-edition-form",
    journalEventType: QidsDeclaredJournalEvent,
    contextualDeclareRoute: "dashboard.main.results-table.scale-surveys"
  });

  new VitalSign({
    key: "ymrs",
    addMeasureForcId: "scale-surveys/ymrs-edition-form",
    journalEventType: YmrsDeclaredJournalEvent,
    contextualDeclareRoute: "dashboard.main.results-table.scale-surveys"
  });

  new VitalSign({
    key: "thymic-episode",
    addMeasureForcId: "thymic-episode/edition-form",
    journalEventType: ThymicEpisodeOccurredJournalEvent
  });

  new VitalSign({
    key: "mammography-and-mri",
    addMeasureForcId: "mammography/edition-form",
    journalEventType: MammographyDeclaredJournalEvent,
    icon: "signal",
    showToPatient: true
  });

  new VitalSign({
    key: "vems-demm",
    addMeasureForcId: "vems/edition-form",
    journalEventType: VemsDeclaredJournalEvent,
    icon: "wind",
    showToPatient: true,
    contextualDeclareRoute: "dashboard.main.results-table.vems"
  });

  new VitalSign({
    key: "oxygene-saturation",
    addMeasureForcId: "oxygene-saturation/edition-form",
    journalEventType: OxygeneSaturationDeclaredJournalEvent,
    icon: "hand pointer outline",
    showToPatient: true,
    contextualDeclareRoute: "dashboard.main.results-table.oxygene-saturation"
  });

  new VitalSign({
    key: "dp-cycle",
    journalEventType: DpSessionDeclaredJournalEvent,
    icon: "file",
    showToPatient: true,
    contextualDeclareRoute: "dp.sessions"
  });

  new VitalSign({
    key: "hemodialysis-session",
    journalEventType: HemodialysisSessionDeclaredJournalEvent,
    icon: "file",
    showToPatient: true,
    contextualDeclareRoute: "hemodialysis.sessions"
  });

  new VitalSign({
    key: "stools-number",
    addMeasureForcId: "stools-number/edition-form",
    journalEventType: StoolsNumberDeclaredJournalEvent,
    icon: "toilet",
    showToPatient: true,
    contextualDeclareRoute: "dashboard.main.results-table.stools-number"
  });

  new VitalSign({
    key: "rch-survey",
    addMeasureForcId: "mici/rch-survey-edition-form",
    addMeasureForcIdMedic: "mici/rch-survey-consult-form",
    journalEventType: RchSurveyFilledJournalEvent,
    icon: "file alternate outline",
    showToPatient: true,
    contextualDeclareRoute: "dashboard.main.results-table.rch-survey"
  });

  new VitalSign({
    key: "crohn-survey",
    addMeasureForcId: "mici/crohn-survey-edition-form",
    addMeasureForcIdMedic: "mici/crohn-survey-consult-form",
    journalEventType: CrohnSurveyFilledJournalEvent,
    icon: "file alternate outline",
    showToPatient: true,
    contextualDeclareRoute: "dashboard.main.results-table.crohn-survey"
  });

  new VitalSign({
    key: "ibd-disk-survey",
    addMeasureForcId: "mici/ibd-disk-survey-edition-form",
    addMeasureForcIdMedic: "mici/ibd-disk-survey-consult-form-details",
    journalEventType: IbdDiskSurveyFilledJournalEvent,
    icon: "smile outline",
    showToPatient: true,
    contextualDeclareRoute: "dashboard.main.results-table.ibd-disk-survey"
  });
}

declare global {
  interface VitalSignRegistry {
    "blood-pressure": BloodPressureMeasuredJournalEvent;
    "respiratory-rate": RespiratoryRateMeasuredJournalEvent;
    temperature: TemperatureMeasuredJournalEvent;
    weight: WeightMeasuredJournalEvent;
    "adverse-events": AdverseEventDeclaredJournalEvent;
    "capillarity-blood-glucose": CapillarityBloodGlucoseMeasuredJournalEvent;
    "kfre-five-years": KfreFiveYearsComputedJournalEvent;
    "kfre-two-years": KfreTwoYearsComputedJournalEvent;
    "mammography-and-mri": MammographyDeclaredJournalEvent;
    "vems-demm": VemsDeclaredJournalEvent;
    "oxygene-saturation": OxygeneSaturationDeclaredJournalEvent;
    "dp-cycle": DpSessionDeclaredJournalEvent;
    "hemodialysis-session": HemodialysisSessionDeclaredJournalEvent;
    "abdominal-area": AbdominalAreaDeclaredJournalEvent;
    eva: FeelingEvasDeclaredJournalEvent;
    fast: FastDeclaredJournalEvent;
    qids: QidsDeclaredJournalEvent;
    ymrs: YmrsDeclaredJournalEvent;
    "thymic-episode": ThymicEpisodeOccurredJournalEvent;
    "stools-number": StoolsNumberDeclaredJournalEvent;
    "rch-survey": RchSurveyFilledJournalEvent;
    "crohn-survey": CrohnSurveyFilledJournalEvent;
    "ibd-disk-survey": IbdDiskSurveyFilledJournalEvent;
  }
}
